if (!customElements.get('floating-image')) {
  customElements.define(
    'floating-image',
    class FloatingImage extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          floaterImages: this.querySelectorAll('.floating-image-with-text__floater-image')
        };

        //gsap scroll trigger each image, subtle parallax effect, eachh image moves at different speed

        this.elements.floaterImages.forEach((image, index) => {
          gsap.to(image, {
            scrollTrigger: {
              trigger: image,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true
            },
            y: -100 - (index * 125),
            ease: 'none',
          });
        });


      


      }

    
    }
  );
}
